module.exports = __webpack_public_path__ + "static/media/reset.7b66831c.svg";